import { render, staticRenderFns } from "./gc-data-grid-report.vue?vue&type=template&id=1b1c9470&scoped=true"
import script from "./gc-data-grid-report.vue?vue&type=script&lang=js"
export * from "./gc-data-grid-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c9470",
  null
  
)

export default component.exports